//This covers PO Box and P.O. Box formats, with or without spaces and periods, case insensitive.
// A USA postal address to a post office will always be PO Box or P.O. Box, so we don't need to cover other formats like "Post Office Box" for this use case.
const PO_BOX_PATTERN = /\bP\.?\s*O\.?\s*BOX\b/i;

export const hasPoBoxAddress = (
  address: string | null | undefined,
  poBox?: string | null,
): boolean => {
  if (poBox && poBox.trim() !== '') return true;
  return !!address && PO_BOX_PATTERN.test(address);
};
